import React, { FC } from 'react';
import { SettingsCardsPageSkeleton, SettingsFormPageSkeleton } from '../settingsSkeleton';

export const StandaloneSiteDetailPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
export const StandaloneSiteCollectionPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
export const StandaloneSiteThemeSettingsPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
